const base = {
  add: "Add",
  clearAll: `Clear all`,
  enableSorting: `Enable sorting`,
  disableSorting: `Disable sorting`
};
function getDefaultTexts(texts) {
  return {
    add: texts?.add ?? base.add,
    clearAll: texts?.clearAll ?? base.clearAll,
    enableSorting: texts?.enableSorting ?? base.enableSorting,
    disableSorting: texts?.disableSorting ?? base.disableSorting
  };
}
export {
  getDefaultTexts
};
//# sourceMappingURL=getDefaultTexts.js.map
